import { IRootState } from '../../../../store'
import { ICardioState } from '../store/cardio.types'

export const getInitialAssessmentCardio = (state: IRootState): ICardioState => state.initialAssessmentCardio
